import { render, staticRenderFns } from "./liveRoomCommodity.vue?vue&type=template&id=7e1b5846&scoped=true&"
import script from "./liveRoomCommodity.vue?vue&type=script&lang=ts&"
export * from "./liveRoomCommodity.vue?vue&type=script&lang=ts&"
import style0 from "./liveRoomCommodity.vue?vue&type=style&index=0&id=7e1b5846&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1b5846",
  null
  
)

export default component.exports